// components/common/FilterRow.jsx
//
// The filter row above every grid: filter boxes first, then the page's own
// controls (chips, switches) as one group. A page puts its search box here —
// `<SearchField className="filter-row-search">` for a plain search,
// or the item filter bar, which renders this row itself — so the box sits in
// the same place, at the same size, on every page.
//
// Layout lives in FilterRow.css, nowhere else.

import React from 'react';
import './FilterRow.css';

export default function FilterRow({ children, actions = null }) {
  return (
    <div className="filter-row">
      <div className="filter-row-boxes">
        {children}
        {/* Grouped so the row's CSS can keep them at content width while the
            filter boxes shrink; not rendered at all when a page passes none. */}
        {actions && <div className="filter-row-actions">{actions}</div>}
      </div>
    </div>
  );
}
